/**
 * Accounts sub-tab — Phase 1 empty state (§5.7.2).
 *
 * The full 6-card grid ships in Phase 2. For now this is a single reassuring
 * card that clarifies the account-connection story is *optional* and only
 * matters if the tenant wants autopost on supported platforms.
 */
import { Link2 } from 'lucide-react';
import { Card } from '@/components/ui/card';

export function AccountsPanel(): JSX.Element {
  return (
    <Card className="p-6">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-muted">
          <Link2 className="h-5 w-5 text-muted-foreground" aria-hidden />
        </div>
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-foreground">
            Publishing setup (optional)
          </h3>
          <p className="max-w-2xl text-sm text-muted-foreground">
            You don&apos;t need to connect any accounts to use Off-Page Brief.
            Connect accounts only if you want to enable autopost for supported
            platforms (LinkedIn / Medium / Dev.to).
          </p>
        </div>
      </div>
    </Card>
  );
}
